import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AlertTriangle, AlertCircle } from "lucide-react";

interface Risk {
  id: number;
  user: string;
  type: string;
  level: string;
  detectedAt: string;
}

interface RiskTableProps {
  risks: Risk[];
  onAnalyze: (id: number) => void;
  isAnalyzing: boolean;
}

const RiskTable = ({ risks, onAnalyze, isAnalyzing }: RiskTableProps) => {
  return (
    <div className="w-full overflow-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[200px]">User</TableHead>
            <TableHead className="w-[200px]">Risk Type</TableHead>
            <TableHead className="w-[150px]">Risk Level</TableHead>
            <TableHead className="w-[200px]">Detected</TableHead>
            <TableHead className="w-[100px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {risks.map((risk) => (
            <TableRow key={risk.id}>
              <TableCell className="font-medium">{risk.user}</TableCell>
              <TableCell>{risk.type}</TableCell>
              <TableCell>
                <div className="flex items-center">
                  <AlertTriangle className={`h-4 w-4 mr-2 ${
                    risk.level === 'High' ? 'text-red-500' :
                    risk.level === 'Medium' ? 'text-yellow-500' :
                    'text-green-500'
                  }`} />
                  {risk.level}
                </div>
              </TableCell>
              <TableCell>{risk.detectedAt}</TableCell>
              <TableCell>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onAnalyze(risk.id)}
                  disabled={isAnalyzing}
                  className="w-full"
                >
                  <AlertCircle className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RiskTable;